import { isGlobalworth, paths } from 'config'
import { DrawerProfiles, Profiles } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.profiles,
    admin: true,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Profiles : DrawerProfiles,
      label: 'nav.profiles',
    },
    component: Loadable({
      component: () => import('./pages/Profiles'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.profileUser,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/ProfileMemberships'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.profileAccessCode,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AccessCode'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addProfile,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddProfile'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.profile,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Profile'),
    }),
    layoutSettings: {},
  },
]

export default routes
